const dominios = window.config.Constantes.Dominios;

export const typeWallFoodit = {
    cookiePremium: "22",
    pathIngresar: "/login/ingresar/S/19/?callback=",
    pathRegistracion: "/login/registracion/S/19/?callback=",
    favicon: "faviconFoodit.ico",
    defaultRedirectUrl: dominios.foodit,
    hasBonificado: false
};

export const typeWallLaNacion = { 
    cookiePremium: "2", 
    pathIngresar: "/login/ingresar/P/1/?callback=", 
    pathRegistracion: "/login/registracion/P/1/?callback=", 
    favicon: "favicon.ico", 
    defaultRedirectUrl: dominios.lanacion, 
    hasBonificado: true 
};

export const typeWallClub = { 
    cookiePremium: "2",
    pathIngresar: "/login/ingresar/D/6/?callback=", 
    pathRegistracion: "/login/registracion/D/6/?callback=", 
    favicon: "favicon.ico", 
    defaultRedirectUrl: dominios.club, 
    hasBonificado: true 
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/configWalls/typeWalls.js